import PageLoader from "components/PageLoader";
import useSurveyInfo from "hooks/useSurveyInfo";

import { surveySelectors } from "modules/survey/infrastructure/store/slice/survey.selectors";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { authStateSelectors } from "store/slices/auth/selectors";
import { useAppSelector } from "store/store.hooks";

const SurveyChose = () => {
  const surveys = useAppSelector(surveySelectors.surveys);

  const navigate = useNavigate();
  const isLogged = useAppSelector(authStateSelectors.userIsLogged);
  const {
    questionaireToResume,
    hasCompletedAllLoggedSurveys,
    lastUnloggedSurveyCompleted,
  } = useSurveyInfo();

  useEffect(() => {
    if (isLogged) {
      if (hasCompletedAllLoggedSurveys) return navigate("end");
      if (questionaireToResume) return navigate(questionaireToResume?.id);
    }
    if (!isLogged) {
      if (lastUnloggedSurveyCompleted)
        return navigate(lastUnloggedSurveyCompleted?.id);
    }
    return navigate(surveys[0]?.id);
  }, [
    hasCompletedAllLoggedSurveys,
    isLogged,
    lastUnloggedSurveyCompleted,
    navigate,
    questionaireToResume,
    surveys,
  ]);

  return <PageLoader />;
};

export default SurveyChose;
